module.exports = __webpack_public_path__ + "static/media/play-button.3a716f88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-button.svg
// module id = 637
// module chunks = 0